import { render, staticRenderFns } from "./app.vue?vue&type=template&id=f4728ed6&scoped=true&"
import script from "./app.vue?vue&type=script&lang=ts&setup=true&"
export * from "./app.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./app.vue?vue&type=style&index=0&id=f4728ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4728ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/Desktop/business/EFM/02 RCP/code/rcp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4728ed6')) {
      api.createRecord('f4728ed6', component.options)
    } else {
      api.reload('f4728ed6', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=f4728ed6&scoped=true&", function () {
      api.rerender('f4728ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/app.vue"
export default component.exports